module.exports = __webpack_public_path__ + "static/30-a2679fe1d6e0826635204eaabbcd9526.jpg";